import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import '../assets/styles/Layout.css';
import Footer from '../components/company/Footer';
import Navbar from '../components/branch/TopNavbar';
import LeftSidebar from '../components/branch/LeftSidebar';

const BranchLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <div className="d-flex flex-column h-100 branch-layout">
      <div className="d-flex flex-grow-1">
        <LeftSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

        <main className={`main-content-area ${isSidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'}`}>
          <Outlet />
        </main>
      </div>

      <div className="footer text-dark">
        <Footer />
      </div>
    </div>
  );
};

export default BranchLayout;
